import Form from '../../../../form_builder_2/form';
import AnalyticsHelper from '../../../../utils/analytics-helper';

export default class PasswordSendOTPView {
    constructor(parent) {
        this.parent = parent;

        this.el = parent.el.querySelector('.password-send-otp-view');
        this.input = this.el.querySelector('input[name=email]');
        this.form = new Form(this.parent.el.querySelector('.password-send-otp-form'), {
            onSuccess: this.onSuccess.bind(this),
            onError: this.onError.bind(this),
        });
    }

    async populateAndSubmit(cbs) {
        await this.populate();
        this.submit(cbs);
    }

    async populate(){
        const details = await window.HONDA.MyAccount2.client.getPersonalDetails();
        if(details) {
            this.input.value = details.email;
        }
    }

    submit(cbs){
        this.form.submit(true, cbs);
    }

    onSuccess(result) {
        this.parent.views['password-validate-otp'].populate({
            otpId: result.id,
            correlation: result.correlation,
            email: this.input.value,
        });
        this.parent.show({ view: 'password-validate-otp' });
        this.analyticsPush(result);
    }

    onError(result) {
        this.form.showError();
        this.analyticsPush(result);
    }

    show() {
        this.el.classList.remove('hide');
    }

    hide() {
        this.el.classList.add('hide');
    }

    back() {
        if (this.parent.params.password) {
            this.parent.hide();
        } else {
            this.parent.show({ view: 'login' });
        }
    }

    analyticsPush(result) {
        AnalyticsHelper.push({
            event: 'my_account',
            eventCategory: 'my account',
            eventAction: 'reset password email submit',
            eventLabel: `${dataLayer[0].productCategory}|My account|submit|internal|#`,
            actionType: 'reset password email submit',
            businessUnit: dataLayer[0].productCategory,
            moduleName: 'My account',
            clickText: 'submit',
            clickType: 'internal',
            destinationURL: '#',
        });
    }
}
